<!--
* @Name：供应商营业业绩
* @Author: 王超
* @Date: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in suppInfoList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>公司：</span>
        <span>{{ item.corpName }}</span>
      </van-row>
      <van-row>
        <span>部门：</span>
        <span>{{ item.departName }}</span>
      </van-row>
      <van-row>
        <span>姓名：</span>
        <span>{{ item.userName }}</span>
      </van-row>
      <van-row>
        <span>手机号：</span>
        <span>{{ item.mobilePhone }}</span>
      </van-row>
      <van-row>
        <span>电话：</span>
        <span>{{ item.telPhone }}</span>
      </van-row>
      <van-row>
        <span>邮箱：</span>
        <span>{{ item.email }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'bidSuppList',
  data() {
    return {}
  },
  props: {
    suppInfoList: {
      type: Array,
      required: true
    }
  },
  computed: {
    enterpriseTypeDictOptions() {
      return this.$store.getters.dicts.enterprise_character
    },
    quoteStatusDictOptions() {
      return this.$store.getters.dicts.quote_status
    }
  }
}
</script>
